import { SVGProps } from 'react';

const RecipesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7.5 6.508a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-9Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 14.508h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5 12.508h-2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v1M12.5 8.508h2M9.5 8.008l.5.5 1-1M12.5 11.508h2M9.5 11.008l.5.5 1-1M12.5 14.508h2M9.5 14.008l.5.5 1-1"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RecipesIcon;
